import Udesk from 'Udesk';
import React, { useCallback } from 'react';
import { Template } from './normal';
import './style.scss';

export default React.memo((props) => {
    const { operatorItem, changeInputValue, disabled = false, source } = props;

    const changeHandle = useCallback(
        (v) => {
            return changeInputValue(operatorItem, 'param', {
                target: { value: { ...v, type: Udesk.enums.operatorTypes.externalInterface.id } },
            });
        },
        [changeInputValue, operatorItem]
    );

    return (
        <Template
            {...{
                value: operatorItem.operatorList[0].param,
                onChange: changeHandle,
                disabled,
                source,
            }}
        />
    );
});
